module.exports = __webpack_public_path__ + "img/256.proper_performance.b31c10d9.svg";